import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Form } from 'react-bootstrap';
import cx from 'classnames';

import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

import Loader from '../../Common/Loader/Loader';
import ToneDropzone from './ToneDropzone';
import CustomCheckbox from '../../Common/CustomCheckbox/CustomCheckbox';
import ToolTipContent from '../../Common/ToolTipContent/ToolTipContent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import onSubmit from './submit';
import validate from './validate';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import { distanceArray } from '../../../helpers/commonHelper';
import { api, toneUploadDir } from '../../../config';
import { deleteTone } from '../../../actions/siteadmin/updateMobileSettings';

import pauseIcon from '/public/Icons/pauseIcon.svg';
import playIcon from '/public/Icons/playIcon.svg';
import deleteIcon from '/public/Icons/deleteIconAudio.svg';

import bt from '../../../components/commonStyle.css';
import s from './MobileSettingsForm.css';


const MobileSettingsForm = (props) => {
  const [play, setPlay] = useState(false);
  const [checkboxError, setCheckboxError] = useState(null);

  const {
    handleSubmit,
    loading = false,
    submitting,
    appForceUpdate,
    requestTone,
    deleteTone: deleteToneAction,
    requestToneFile,
    intl: { formatMessage }
  } = props;

  const togglePlay = () => {
    const audioEl = document.getElementsByClassName("audio-element")[0];
    setPlay(!play);
    play ? audioEl.pause() : audioEl.play();
  };

  const renderCheckbox = ({ input, meta: { touched, error }, name }) => {
    setCheckboxError(touched && error ? formatMessage(error) : null);
    input.value = input.value == '1' ? true : false;
    return (
      <div>
        <CustomCheckbox
          name={name}
          className='commonCustomCheckBox'
          containerClassName="commonCustomCheckWithoutLabelFlex"
          checked={input.value}
          onChange={event => {
            return input.onChange(event);
          }}
        />
      </div>
    );
  };

  const distanceData = distanceArray(5, 100);
  const distanceDataOptions = distanceData.map((item, index) => {
    return {
      value: item,
      label: item
    }
  })

  const hideShowOptions = [
    { value: '0', label: formatMessage(messages.hide) },
    { value: '1', label: formatMessage(messages.show) }
  ]

  const enableDisableOptions = [
    { value: '0', label: formatMessage(messages.Disable) },
    { value: '1', label: formatMessage(messages.Enable) }
  ]

  const forceUpdateOptions = [
    { value: 'false', label: formatMessage(messages.Disable) },
    { value: 'true', label: formatMessage(messages.Enable) }
  ]
  return (
    <div>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.mobileSettings)}</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='twoColumnGrid'>
          <Field
            name="allowedServices"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.allowedServices)}
            placeholder={formatMessage(messages.allowedServices)}
            toolTipText={formatMessage(messages.appSettingMaximumSubCategoriesTooltip)}
            showToolTip
          />

          <Field
            name="notificationInterval"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.notificationInterval)}
            placeholder={formatMessage(messages.notificationInterval)}
            toolTipText={formatMessage(messages.appSettingJobAcceptanceServiceProviderTooltip)}
            suffixLabel={formatMessage(messages.minLableText)}
            maxLength={3}
            showToolTip
            isAddon
          />

          <Field
            name="allowableDistace"
            component={SelectFieldComponent}
            label={formatMessage(messages.allowableDistaceTitle)}
            options={distanceDataOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingMaximumDistanceTooltip)}
          />

          <Field
            name="maximumEmergencyContact"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.maximumEmergencyContact)}
            placeholder={formatMessage(messages.maximumEmergencyContact)}
            toolTipText={formatMessage(messages.appSettingMaximumEmergencyTooltip)}
            showToolTip
          />
          <Field
            name="defaultScheduleInterval"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.defaultScheduleInterval)}
            placeholder={formatMessage(messages.defaultScheduleInterval)}
            toolTipText={formatMessage(messages.appSettingScheduleIntervalTooltip)}
            suffixLabel={formatMessage(messages.minLableText)}
            maxLength={3}
            showToolTip
            isAddon
          />

          <Field
            name="addtionalWorkInterval"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.additionalWorkInterval)}
            placeholder={formatMessage(messages.additionalWorkInterval)}
            toolTipText={formatMessage(messages.appSettingAdditionWorkTooltip)}
            suffixLabel={formatMessage(messages.minLableText)}
            maxLength={3}
            showToolTip
            isAddon
          />

          <Field
            name="maximumProviders"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.preferredServiceProviderCount)}
            placeholder={formatMessage(messages.preferredServiceProviderCount)}
            toolTipText={formatMessage(messages.appSettingPreferredServiceTooltip)}
            showToolTip
          />
        </div>

        <div className={bt.sectionDividerBorder} />

        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.manageForceUpdate)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="appForceUpdate"
            component={SelectFieldComponent}
            label={formatMessage(messages.forceUpdate)}
            options={forceUpdateOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingForceUpdateTooltip)}

          />
        </div>

        {String(appForceUpdate) === 'true' && (
          <div className={cx('twoColumnGrid', bt.spaceTop3)}>
            <Field
              name="userAndroidVersion"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.userAndriodVersion)}
              placeholder={formatMessage(messages.userAndriodVersion)}
              toolTipText={formatMessage(messages.appSettingAndroidVersionTooltip)}
              prefixLabel={'V'}
              maxLength={10}
              showToolTip
              isAddon
            />

            <Field
              name="userIosVersion"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.useriosVersion)}
              placeholder={formatMessage(messages.useriosVersion)}
              toolTipText={formatMessage(messages.appSettingIosVersionTooltip)}
              prefixLabel={'V'}
              maxLength={10}
              showToolTip
              isAddon
            />

            <Field
              name="partnerAndroidVersion"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.partnerAndriodVersion)}
              placeholder={formatMessage(messages.partnerAndriodVersion)}
              toolTipText={formatMessage(messages.appSettingServiceProviderAndroidVersionTooltip)}
              prefixLabel={'V'}
              maxLength={10}
              showToolTip
              isAddon
            />

            <Field
              name="partnerIosVersion"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.partneriosVersion)}
              placeholder={formatMessage(messages.partneriosVersion)}
              toolTipText={formatMessage(messages.appSettingServiceProviderIosVersionTooltip)}
              prefixLabel={'V'}
              maxLength={10}
              showToolTip
              isAddon
            />
          </div>
        )}

        <div className={bt.sectionDividerBorder} />

        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.jobRequestWindow)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="duration"
            component={SelectFieldComponent}
            label={formatMessage(messages.duration)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingJobAcceptanceTimeTooltip)}
          />

          <Field
            name="job"
            component={SelectFieldComponent}
            label={formatMessage(messages.job)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingJobListTooltip)}
          />

          <Field
            name="photo"
            component={SelectFieldComponent}
            label={formatMessage(messages.jobPhoto)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingJobPhotoTooltip)}
          />

          <Field
            name="description"
            component={SelectFieldComponent}
            label={formatMessage(messages.jobDescription)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingJobDescriptionTooltip)}
          />

          <Field
            name="estimatedPrice"
            component={SelectFieldComponent}
            label={formatMessage(messages.estimatedPrice)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingEstimatedPriceTooltip)}
          />

          <Field
            name="location"
            component={SelectFieldComponent}
            label={formatMessage(messages.jobLocation)}
            options={hideShowOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingJobLocationTooltip)}
          />

          <Field
            name="openAppOnRequest"
            component={SelectFieldComponent}
            label={formatMessage(messages.appOpenRequest)}
            options={enableDisableOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingProviderAppNotificationTooltip)}
          />

          <Field
            name="isRequestTimerToneEnable"
            component={SelectFieldComponent}
            label={formatMessage(messages.requestTone)}
            options={enableDisableOptions}
            inputClass={bt.formControlSelect}
            showToolTip
            toolTipText={formatMessage(messages.appSettingRequestTimerToneTooltip)}
          />

          <Form.Group className={s.noMargin}>
            <h2 className={cx('siteAdminSecondaryHeading', 'svgImg')}>
              {formatMessage(messages.uploadRequestTone)}&nbsp;
              <ToolTipContent label={formatMessage(messages.appSettingUploadTimerToneTooltip)} />
            </h2>
            {!requestTone && (
              <ToneDropzone
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
              />
            )}
            {requestTone && (
              <div className={s.audioSection}>
                <div>{requestToneFile}</div>
                <div className={s.flex}>
                  <span className={s.audioImgContainer} onClick={togglePlay}>
                    {play ? <img src={pauseIcon} alt="Pause" /> : <img src={playIcon} alt="Play" />}
                  </span>
                  <span className={s.audioImgContainer} onClick={() => deleteToneAction(requestTone)}>
                    <img src={deleteIcon} alt="Delete" />
                  </span>
                </div>
                <audio className="audio-element">
                  <source src={api.apiEndpoint + toneUploadDir + requestTone}></source>
                </audio>
              </div>
            )}
          </Form.Group>

          <Form.Group className={s.noMargin}>
            <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.bookingMethods)}</h2>
            <div className={s.flexBox}>
              <Field name="randomProviderSelection" component={renderCheckbox} className={cx(bt.formControlSelect)} />
              <label className={cx(bt.commonLabelText, s.noMargin, 'svgImg')}><FormattedMessage {...messages.randomProviderSelection} />
                <ToolTipContent label={formatMessage(messages.randomProviderSelectionTooltip)} />
              </label>
            </div>
            <div className={s.flexBox}>
              <Field name="preferredProviderSelection" component={renderCheckbox} className={cx(bt.formControlSelect)} />
              <label className={cx(bt.commonLabelText, s.noMargin, 'svgImg')}><FormattedMessage {...messages.preferredProviderSelection} />
                <ToolTipContent label={formatMessage(messages.preferredProviderSelectionTooltip)} />
              </label>
            </div>
            {checkboxError && <span className={bt.errorMessage}>{checkboxError}</span>}
          </Form.Group>
        </div>

        <div className={bt.sectionDividerBorder} />
        <h2 className={cx('siteAdminSecondaryHeading', 'svgImg')}>
          {formatMessage(messages.Support)}&nbsp;
          <ToolTipContent label={formatMessage(messages.appSettingSupportTooltip)} />
        </h2>

        <div className='threeColumnGrid'>
          <Field
            name="contactPhoneNumber"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.contactPhoneNumber)}
            placeholder={formatMessage(messages.contactPhoneNumber)}
            toolTipText={formatMessage(messages.appSettingContactNoTooltip)}
            maxLength={15}
            showToolTip
          />

          <Field
            name="contactEmail"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.contactEmail)}
            placeholder={formatMessage(messages.contactEmail)}
            toolTipText={formatMessage(messages.appSettingContactEmailTooltip)}
            showToolTip
          />

          <Field
            name="whatsApp"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.whatsAppLabel)}
            placeholder={formatMessage(messages.whatsAppPlaceholderLabel)}
            toolTipText={formatMessage(messages.appSettingsWhatsAppToolTip)}
            showToolTip
          />
        </div>

        <div className={bt.sectionDividerBorder} />
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.googleMapLabel)}</h2>

        <div className='twoColumnGrid'>
          <Field
            name="userAppAndroidMapAPIKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.userAppAndroidMapApiKey)}
            placeholder={formatMessage(messages.userAppAndroidMapApiKey)}
            toolTipText={formatMessage(messages.userAppAndroidTooltip)}
            maxLength={50}
            showToolTip
          />

          <Field
            name="serviceProviderAppAndroidMapAPIKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.serviceProviderAppAndroidMapAPIKey)}
            placeholder={formatMessage(messages.serviceProviderAppAndroidMapAPIKey)}
            toolTipText={formatMessage(messages.serviceProviderAndroidTooltip)}
            maxLength={50}
            showToolTip
          />

          <Field
            name="userAppIosMapAPIKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.userAppIosMapApiKey)}
            placeholder={formatMessage(messages.userAppIosMapApiKey)}
            toolTipText={formatMessage(messages.userAppIosTooltip)}
            maxLength={50}
            showToolTip
          />

          <Field
            name="serviceProviderAppIosMapAPIKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.serviceProviderIosMapAPIKey)}
            placeholder={formatMessage(messages.serviceProviderIosMapAPIKey)}
            toolTipText={formatMessage(messages.serviceProviderIosTooltip)}
            maxLength={50}
            showToolTip
          />
        </div>

        <div className='commonButtonContainer'>
          <Loader
            type={"button"}
            label={formatMessage(messages.submitButton)}
            show={loading}
            buttonType={'submit'}
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting || loading}
          />
        </div>
      </form>
    </div >
  );
};

MobileSettingsForm.defaultProps = { loading: false };

const selector = formValueSelector('MobileSettingsForm');

const mapState = (state) => ({
  appForceUpdate: selector(state, 'appForceUpdate'),
  loading: state.loader.MobileSettings,
  requestTone: selector(state, 'requestTimeTone'),
  requestToneFile: selector(state, 'requestToneFile'),
});

const mapDispatch = {
  deleteTone
};

const FormComponent = reduxForm({
  form: 'MobileSettingsForm',
  onSubmit,
  validate
})(MobileSettingsForm);

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(FormComponent)));